import { addDefaultIfEmpty, insertAfterIndex, removeAtIndex, sum, updateAtIndex } from "../../helpers/array"
import { uniqueId } from '../../helpers/uniqueId'

export type SalesGoal = {
  id: string,
  description: string,
  annualRevenue: number
}

export const emptySalesGoal = (): SalesGoal => ({ id: uniqueId(), description: '', annualRevenue: 0 })

export const createDefaultSalesGoals = (): SalesGoal[] => [
  emptySalesGoal()
]

export const sumSalesGoals = (salesGoals: SalesGoal[]): number =>
  sum(salesGoals, x => x.annualRevenue)

export const updateAnnualRevenue = (salesGoals: SalesGoal[], index: number, annualRevenue: number): SalesGoal[] =>
  updateAtIndex(salesGoals, index, x => ({ ...x, annualRevenue }))

export const updateDescription = (salesGoals: SalesGoal[], index: number, description: string): SalesGoal[] =>
  updateAtIndex(salesGoals, index, x => ({ ...x, description }))

export const add = (salesGoals: SalesGoal[], index: number) =>
  insertAfterIndex(salesGoals, index, emptySalesGoal())

export const remove = (salesGoals: SalesGoal[], index: number) =>
  addDefaultIfEmpty(removeAtIndex(salesGoals, index), emptySalesGoal())

export const enforceInvariants = (salesGoals: SalesGoal[] | undefined): SalesGoal[] => {
  return salesGoals && salesGoals.length > 0 ? salesGoals : createDefaultSalesGoals()
}